import Icons from 'components/atoms/Icons';
import React, { ReactNode, useState } from 'react';

type SidebarProps<T extends ReactNode> = {
	header: string;
	pageType: string;
	children: T;
	customHeader?: string;
};

const Sidebar = <T extends ReactNode>({
	header,
	pageType,
	children,
	customHeader,
}: SidebarProps<T>): JSX.Element => {
	const [isOpen, setIsOpen] = useState(false);
	return (
		<div className="sidebar-container">
			<div
				className={`${isOpen ? 'sidebar open' : 'sidebar'} ${
					pageType == 'provider' ? 'provider' : 'location'
				}`}
			>
				{pageType == 'provider' ? (
					<h3
						className={`header ${customHeader ? customHeader : ''}`}
						onClick={() => setIsOpen(!isOpen)}
					>
						{header}
						{isOpen ? <Icons id="chevron-down" /> : <Icons id="chevron-up" />}
					</h3>
				) : (
					<h2
						className={`header ${customHeader ? customHeader : ''}`}
						onClick={() => setIsOpen(!isOpen)}
					>
						{header}
						{isOpen ? <Icons id="chevron-down" /> : <Icons id="chevron-up" />}
					</h2>
				)}
				<div className="sidebar-content-wrapper">
					<div className="sidebar-content">{children}</div>
				</div>
			</div>
		</div>
	);
};

export default Sidebar;
